"use strict";var __importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.LogoContainer=exports.RightElement=exports.LeftElement=exports.LoginLogo=exports.LogoDiv=exports.StyledDiv=void 0;const jsx_runtime_1=require("react/jsx-runtime"),styled_components_1=__importDefault(require("styled-components")),CI="/icons/ci.svg",LeftElementSvg="/icons/signin-left-element.svg",RightElementSvg="/icons/signin-right-element.svg";exports.StyledDiv=styled_components_1.default.div`
  margin: auto;
  width: 360px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-sizing: border-box;
`;const StyledLogoDiv=styled_components_1.default.div`
  z-index: 1;
  position: absolute;
  top: 60px;
  left: 60px;
  
  @media screen and (max-width: 480px) {
    left: 50%;
    transform: translateX(-50%);
  }
`,StyledLogoImage=styled_components_1.default.img`
  /* cursor: pointer; */
  display: flex;
  /* align-items: flex-start; */
  /* width: 176px;
  height: 30px; */
`,LogoDiv=({src:e=CI,onClick:t})=>(0,jsx_runtime_1.jsx)(StyledLogoDiv,{children:(0,jsx_runtime_1.jsx)(StyledLogoImage,{src:e,alt:"DeepBrain AI",onClick:t})});exports.LogoDiv=LogoDiv;const LoginLogoDiv=styled_components_1.default.div``,LoginLogo=({src:e=CI,onClick:t})=>(0,jsx_runtime_1.jsx)(LoginLogoDiv,{children:(0,jsx_runtime_1.jsx)(StyledLogoImage,{src:e,alt:"DeepBrain AI",onClick:t})});exports.LoginLogo=LoginLogo;const StyledLeftElement=styled_components_1.default.img`
  z-index: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 360px;
  height: 344px;
  pointer-event: none;
  @media screen and (max-width: 1200px) {
    left: calc(50% - 1200px / 2);
  }
`,LeftElement=()=>(0,jsx_runtime_1.jsx)(StyledLeftElement,{src:LeftElementSvg,alt:""});exports.LeftElement=LeftElement;const StyledRightElement=styled_components_1.default.img`
  z-index: 0;
  position: fixed;
  top: 0;
  right: 0;
  width: 360px;
  height: 344px;
  pointer-event: none;
  @media screen and (max-width: 1200px) {
    right: calc(50% - 1200px / 2);
  }
`,RightElement=()=>(0,jsx_runtime_1.jsx)(StyledRightElement,{src:RightElementSvg,alt:""});exports.RightElement=RightElement,exports.LogoContainer=styled_components_1.default.div`
  padding: 30px 0px;
  margin-top: 20px 0px;
`;